import { API } from 'aws-amplify';

export default {
  /**
   * Get airops messages for a user from DB
   */
  getAiropsMessage(variables) {
    const query = `
      query getAirOpsMessages($userId: String!) {
        response: getAirOpsMessages(userId: $userId) {
          data {
            executionId
            inputQuery
            isLoading
            queryResponse
            timestamp
            userId
          }
          nextToken
        }
      }
    `;

    return API.graphql({
      query,
      variables,
    });
  },

  /**
   * Save execution id to DB
   */
  saveAiropsMessage(variables) {
    const query = `
      mutation addAirOpsMessage($executionId: String!, $inputQuery: String!, $queryType: String!, $timestamp: String!, $userId: String!) {
        response: addAirOpsMessage(executionId: $executionId, inputQuery: $inputQuery, queryType: $queryType, timestamp: $timestamp, userId: $userId) {
          executionId
          inputQuery
          queryType
          timestamp
          userId
        }
      }
    `;

    return API.graphql({
      query,
      variables,
    });
  },

  /**
   * Rename airops input query
   */
  renameAiropsMessage(variables) {
    const query = `
      mutation renameAirOpsMessage($executionId: String!, $inputQuery: String!, $timestamp: String!, $userId: String!) {
        response: renameAirOpsMessage(executionId: $executionId, inputQuery: $inputQuery, timestamp: $timestamp, userId: $userId) {
          executionId
          inputQuery
          timestamp
          userId
        }
      }
    `;

    return API.graphql({
      query,
      variables,
    });
  },

  /**
   * Delete airops message
   */
  deleteAiropsMessage(variables) {
    const query = `
      mutation deleteAirOpsMessage($executionId: String!, $timestamp: String!, $userId: String!) {
        response: deleteAirOpsMessage(executionId: $executionId, timestamp: $timestamp, userId: $userId) {
          executionId
          timestamp
          userId
        }
      }
    `;

    return API.graphql({
      query,
      variables,
    });
  },

  /**
   * Update airops query response
   */
  updateAiropsMessage(variables) {
    const query = `
      mutation updateAirOpsResponse($executionId: String!, $queryResponse: String!, $timestamp: String!, $userId: String!) {
        response: updateAirOpsResponse(executionId: $executionId, queryResponse: $queryResponse, timestamp: $timestamp, userId: $userId) {
          executionId
          inputQuery
          timestamp
          userId
        }
      }
    `;

    return API.graphql({
      query,
      variables,
    });
  },

  /**
   * Fetch airops products
   */
  fetchAirOpsProducts() {
    const query = `
      query fetchAirOpsProducts {
        response: fetchAirOpsProducts {
          products
        }
      }
    `;

    return API.graphql({
      query,
    });
  },
};